import { jsx as S, jsxs as Te, Fragment as nt } from "react/jsx-runtime";
import { c as se } from "../clsx-OuTLNxxd.js";
import * as E from "react";
import i, { useMemo as Jt, useLayoutEffect as Zt, useEffect as Qt } from "react";
import { c as we, a as en } from "../index-BmuVeYZj.js";
import { u as Be, S as tn } from "../index-COKuFRlK.js";
import { c as nn, P as ve, a as rn } from "../index-0mHpcs5Z.js";
import { u as Pe } from "../index-C8E6Kp7g.js";
import { D as an, P as on } from "../index-BlGjxs-7.js";
import { R as sn, h as ln, u as un, F as cn } from "../Combination-CyXYnuSs.js";
import { P as ke } from "../index-a4ExZw7H.js";
import "../Drawer.css?__remix_sideEffect__";var Le = "Dialog",[st, Or] = nn(Le),[dn, q] = st(Le),lt = (e) => {
    const {
        __scopeDialog: n,
        children: t,
        open: a,
        defaultOpen: o,
        onOpenChange: r,
        modal: l = !0
      } = e,s = E.useRef(null),p = E.useRef(null),[x = !1, h] = en({
        prop: a,
        defaultProp: o,
        onChange: r
      });
    return /* @__PURE__ */S(
      dn,
      {
        scope: n,
        triggerRef: s,
        contentRef: p,
        contentId: Pe(),
        titleId: Pe(),
        descriptionId: Pe(),
        open: x,
        onOpenChange: h,
        onOpenToggle: E.useCallback(() => h((g) => !g), [h]),
        modal: l,
        children: t
      }
    );
  };
lt.displayName = Le;
var ut = "DialogTrigger",ct = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, ...a } = e,o = q(ut, t),r = Be(n, o.triggerRef);
      return /* @__PURE__ */S(
        ve.button,
        {
          type: "button",
          "aria-haspopup": "dialog",
          "aria-expanded": o.open,
          "aria-controls": o.contentId,
          "data-state": Ve(o.open),
          ...a,
          ref: r,
          onClick: we(e.onClick, o.onOpenToggle)
        }
      );
    }
  );
ct.displayName = ut;
var ze = "DialogPortal",[fn, dt] = st(ze, {
    forceMount: void 0
  }),ft = (e) => {
    const { __scopeDialog: n, forceMount: t, children: a, container: o } = e,r = q(ze, n);
    return /* @__PURE__ */S(fn, { scope: n, forceMount: t, children: E.Children.map(a, (l) => /* @__PURE__ */S(ke, { present: t || r.open, children: /* @__PURE__ */S(on, { asChild: !0, container: o, children: l }) })) });
  };
ft.displayName = ze;
var Ee = "DialogOverlay",mt = E.forwardRef(
    (e, n) => {
      const t = dt(Ee, e.__scopeDialog),{ forceMount: a = t.forceMount, ...o } = e,r = q(Ee, e.__scopeDialog);
      return r.modal ? /* @__PURE__ */S(ke, { present: a || r.open, children: /* @__PURE__ */S(mn, { ...o, ref: n }) }) : null;
    }
  );
mt.displayName = Ee;
var mn = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, ...a } = e,o = q(Ee, t);
      return (
        // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
        // ie. when `Overlay` and `Content` are siblings
        /* @__PURE__ */S(sn, { as: tn, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */S(
            ve.div,
            {
              "data-state": Ve(o.open),
              ...a,
              ref: n,
              style: { pointerEvents: "auto", ...a.style }
            }
          ) }));

    }
  ),re = "DialogContent",gt = E.forwardRef(
    (e, n) => {
      const t = dt(re, e.__scopeDialog),{ forceMount: a = t.forceMount, ...o } = e,r = q(re, e.__scopeDialog);
      return /* @__PURE__ */S(ke, { present: a || r.open, children: r.modal ? /* @__PURE__ */S(gn, { ...o, ref: n }) : /* @__PURE__ */S(pn, { ...o, ref: n }) });
    }
  );
gt.displayName = re;
var gn = E.forwardRef(
    (e, n) => {
      const t = q(re, e.__scopeDialog),a = E.useRef(null),o = Be(n, t.contentRef, a);
      return E.useEffect(() => {
        const r = a.current;
        if (r) return ln(r);
      }, []), /* @__PURE__ */S(
        pt,
        {
          ...e,
          ref: o,
          trapFocus: t.open,
          disableOutsidePointerEvents: !0,
          onCloseAutoFocus: we(e.onCloseAutoFocus, (r) => {
            var l;
            r.preventDefault(), (l = t.triggerRef.current) == null || l.focus();
          }),
          onPointerDownOutside: we(e.onPointerDownOutside, (r) => {
            const l = r.detail.originalEvent,s = l.button === 0 && l.ctrlKey === !0;
            (l.button === 2 || s) && r.preventDefault();
          }),
          onFocusOutside: we(
            e.onFocusOutside,
            (r) => r.preventDefault()
          )
        }
      );
    }
  ),pn = E.forwardRef(
    (e, n) => {
      const t = q(re, e.__scopeDialog),a = E.useRef(!1),o = E.useRef(!1);
      return /* @__PURE__ */S(
        pt,
        {
          ...e,
          ref: n,
          trapFocus: !1,
          disableOutsidePointerEvents: !1,
          onCloseAutoFocus: (r) => {
            var l, s;
            (l = e.onCloseAutoFocus) == null || l.call(e, r), r.defaultPrevented || (a.current || (s = t.triggerRef.current) == null || s.focus(), r.preventDefault()), a.current = !1, o.current = !1;
          },
          onInteractOutside: (r) => {
            var p, x;
            (p = e.onInteractOutside) == null || p.call(e, r), r.defaultPrevented || (a.current = !0, r.detail.originalEvent.type === "pointerdown" && (o.current = !0));
            const l = r.target;
            ((x = t.triggerRef.current) == null ? void 0 : x.contains(l)) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && o.current && r.preventDefault();
          }
        }
      );
    }
  ),pt = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, trapFocus: a, onOpenAutoFocus: o, onCloseAutoFocus: r, ...l } = e,s = q(re, t),p = E.useRef(null),x = Be(n, p);
      return un(), /* @__PURE__ */Te(nt, { children: [
        /* @__PURE__ */S(
          cn,
          {
            asChild: !0,
            loop: !0,
            trapped: a,
            onMountAutoFocus: o,
            onUnmountAutoFocus: r,
            children: /* @__PURE__ */S(
              an,
              {
                role: "dialog",
                id: s.contentId,
                "aria-describedby": s.descriptionId,
                "aria-labelledby": s.titleId,
                "data-state": Ve(s.open),
                ...l,
                ref: x,
                onDismiss: () => s.onOpenChange(!1)
              }
            )
          }
        ),
        /* @__PURE__ */Te(nt, { children: [
          /* @__PURE__ */S(hn, { titleId: s.titleId }),
          /* @__PURE__ */S(vn, { contentRef: p, descriptionId: s.descriptionId })]
        })]
      });
    }
  ),Ue = "DialogTitle",ht = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, ...a } = e,o = q(Ue, t);
      return /* @__PURE__ */S(ve.h2, { id: o.titleId, ...a, ref: n });
    }
  );
ht.displayName = Ue;
var wt = "DialogDescription",vt = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, ...a } = e,o = q(wt, t);
      return /* @__PURE__ */S(ve.p, { id: o.descriptionId, ...a, ref: n });
    }
  );
vt.displayName = wt;
var yt = "DialogClose",xt = E.forwardRef(
    (e, n) => {
      const { __scopeDialog: t, ...a } = e,o = q(yt, t);
      return /* @__PURE__ */S(
        ve.button,
        {
          type: "button",
          ...a,
          ref: n,
          onClick: we(e.onClick, () => o.onOpenChange(!1))
        }
      );
    }
  );
xt.displayName = yt;
function Ve(e) {
  return e ? "open" : "closed";
}
var bt = "DialogTitleWarning",[_r, Dt] = rn(bt, {
    contentName: re,
    titleName: Ue,
    docsSlug: "dialog"
  }),hn = ({ titleId: e }) => {
    const n = Dt(bt),t = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
    return E.useEffect(() => {
      e && (document.getElementById(e) || console.error(t));
    }, [t, e]), null;
  },wn = "DialogDescriptionWarning",vn = ({ contentRef: e, descriptionId: n }) => {
    const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Dt(wn).contentName}}.`;
    return E.useEffect(() => {
      var r;
      const o = (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby");
      n && o && (document.getElementById(n) || console.warn(a));
    }, [a, e, n]), null;
  },yn = lt,xn = ct,bn = ft,Dn = mt,Rn = gt,Sn = ht,Tn = vt,En = xt;
function Cn(e) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0],t = document.createElement("style");
  t.type = "text/css", n.appendChild(t), t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
const Rt = i.createContext({
    drawerRef: {
      current: null
    },
    overlayRef: {
      current: null
    },
    onPress: () => {
    },
    onRelease: () => {
    },
    onDrag: () => {
    },
    onNestedDrag: () => {
    },
    onNestedOpenChange: () => {
    },
    onNestedRelease: () => {
    },
    openProp: void 0,
    dismissible: !1,
    isOpen: !1,
    isDragging: !1,
    keyboardIsOpen: {
      current: !1
    },
    snapPointsOffset: null,
    snapPoints: null,
    handleOnly: !1,
    modal: !1,
    shouldFade: !1,
    activeSnapPoint: null,
    onOpenChange: () => {
    },
    setActiveSnapPoint: () => {
    },
    closeDrawer: () => {
    },
    direction: "bottom",
    shouldAnimate: {
      current: !0
    },
    shouldScaleBackground: !1,
    setBackgroundColorOnScale: !0,
    noBodyStyles: !1,
    container: null,
    autoFocus: !1
  }),le = () => {
    const e = i.useContext(Rt);
    if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
    return e;
  };
Cn(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function On() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function _n() {
  return Ye(/^Mac/);
}
function Nn() {
  return Ye(/^iPhone/);
}
function rt() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function An() {
  return Ye(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  _n() && navigator.maxTouchPoints > 1;
}
function St() {
  return Nn() || An();
}
function Ye(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Pn = 24,Mn = typeof window < "u" ? Zt : Qt;
function at(...e) {
  return (...n) => {
    for (let t of e)
    typeof t == "function" && t(...n);
  };
}
const Me = typeof document < "u" && window.visualViewport;
function ot(e) {
  let n = window.getComputedStyle(e);
  return /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
}
function Tt(e) {
  for (ot(e) && (e = e.parentElement); e && !ot(e);)
  e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const In = /* @__PURE__ */new Set([
"checkbox",
"radio",
"range",
"color",
"file",
"image",
"button",
"submit",
"reset"]
);
let De = 0,Ie;
function $n(e = {}) {
  let { isDisabled: n } = e;
  Mn(() => {
    if (!n)
    return De++, De === 1 && St() && (Ie = Hn()), () => {
      De--, De === 0 && (Ie == null || Ie());
    };
  }, [
  n]
  );
}
function Hn() {
  let e,n = 0,t = (g) => {
      e = Tt(g.target), !(e === document.documentElement && e === document.body) && (n = g.changedTouches[0].pageY);
    },a = (g) => {
      if (!e || e === document.documentElement || e === document.body) {
        g.preventDefault();
        return;
      }
      let w = g.changedTouches[0].pageY,L = e.scrollTop,B = e.scrollHeight - e.clientHeight;
      B !== 0 && ((L <= 0 && w > n || L >= B && w < n) && g.preventDefault(), n = w);
    },o = (g) => {
      let w = g.target;
      We(w) && w !== document.activeElement && (g.preventDefault(), w.style.transform = "translateY(-2000px)", w.focus(), requestAnimationFrame(() => {
        w.style.transform = "";
      }));
    },r = (g) => {
      let w = g.target;
      We(w) && (w.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
        w.style.transform = "", Me && (Me.height < window.innerHeight ? requestAnimationFrame(() => {
          it(w);
        }) : Me.addEventListener("resize", () => it(w), {
          once: !0
        }));
      }));
    },l = () => {
      window.scrollTo(0, 0);
    },s = window.pageXOffset,p = window.pageYOffset,x = at(Wn(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let h = at(pe(document, "touchstart", t, {
    passive: !1,
    capture: !0
  }), pe(document, "touchmove", a, {
    passive: !1,
    capture: !0
  }), pe(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), pe(document, "focus", r, !0), pe(window, "scroll", l));
  return () => {
    x(), h(), window.scrollTo(s, p);
  };
}
function Wn(e, n, t) {
  let a = e.style[n];
  return e.style[n] = t, () => {
    e.style[n] = a;
  };
}
function pe(e, n, t, a) {
  return e.addEventListener(n, t, a), () => {
    e.removeEventListener(n, t, a);
  };
}
function it(e) {
  let n = document.scrollingElement || document.documentElement;
  for (; e && e !== n;) {
    let t = Tt(e);
    if (t !== document.documentElement && t !== document.body && t !== e) {
      let a = t.getBoundingClientRect().top,o = e.getBoundingClientRect().top,r = e.getBoundingClientRect().bottom;
      const l = t.getBoundingClientRect().bottom + Pn;
      r > l && (t.scrollTop += o - a);
    }
    e = t.parentElement;
  }
}
function We(e) {
  return e instanceof HTMLInputElement && !In.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Fn(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function Bn(...e) {
  return (n) => e.forEach((t) => Fn(t, n));
}
function Et(...e) {
  return E.useCallback(Bn(...e), e);
}
const Ct = /* @__PURE__ */new WeakMap();
function A(e, n, t = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let a = {};
  Object.entries(n).forEach(([o, r]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, r);
      return;
    }
    a[o] = e.style[o], e.style[o] = r;
  }), !t && Ct.set(e, a);
}
function kn(e, n) {
  if (!e || !(e instanceof HTMLElement)) return;
  let t = Ct.get(e);
  t && (e.style[n] = t[n]);
}
const N = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Re(e, n) {
  if (!e)
  return null;
  const t = window.getComputedStyle(e),a =
    // @ts-ignore
    t.transform || t.webkitTransform || t.mozTransform;

  let o = a.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[N(n) ? 13 : 12]) : (o = a.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[N(n) ? 5 : 4]) : null);
}
function Ln(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function $e(e, n) {
  if (!e) return () => {
  };
  const t = e.style.cssText;
  return Object.assign(e.style, n), () => {
    e.style.cssText = t;
  };
}
function zn(...e) {
  return (...n) => {
    for (const t of e)
    typeof t == "function" && t(...n);
  };
}
const O = {
    DURATION: 0.5,
    EASE: [
    0.32,
    0.72,
    0,
    1]

  },Ot = 0.4,Un = 0.25,Vn = 100,_t = 8,Se = 16,Fe = 26,He = "vaul-dragging";
function Nt(e) {
  const n = i.useRef(e);
  return i.useEffect(() => {
    n.current = e;
  }), i.useMemo(() => (...t) => n.current == null ? void 0 : n.current.call(n, ...t), []);
}
function Yn({ defaultProp: e, onChange: n }) {
  const t = i.useState(e),[a] = t,o = i.useRef(a),r = Nt(n);
  return i.useEffect(() => {
    o.current !== a && (r(a), o.current = a);
  }, [
  a,
  o,
  r]
  ), t;
}
function At({ prop: e, defaultProp: n, onChange: t = () => {
  } }) {
  const [a, o] = Yn({
      defaultProp: n,
      onChange: t
    }),r = e !== void 0,l = r ? e : a,s = Nt(t),p = i.useCallback((x) => {
      if (r) {
        const g = typeof x == "function" ? x(e) : x;
        g !== e && s(g);
      } else
      o(x);
    }, [
    r,
    e,
    o,
    s]
    );
  return [
  l,
  p];

}
function jn({ activeSnapPointProp: e, setActiveSnapPointProp: n, snapPoints: t, drawerRef: a, overlayRef: o, fadeFromIndex: r, onSnapPointChange: l, direction: s = "bottom", container: p, snapToSequentialPoint: x }) {
  const [h, g] = At({
      prop: e,
      defaultProp: t == null ? void 0 : t[0],
      onChange: n
    }),[w, L] = i.useState(typeof window < "u" ? {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight
    } : void 0);
  i.useEffect(() => {
    function d() {
      L({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", d), () => window.removeEventListener("resize", d);
  }, []);
  const B = i.useMemo(() => h === (t == null ? void 0 : t[t.length - 1]) || null, [
    t,
    h]
    ),C = i.useMemo(() => {
      var d;
      return (d = t == null ? void 0 : t.findIndex((D) => D === h)) != null ? d : null;
    }, [
    t,
    h]
    ),z = t && t.length > 0 && (r || r === 0) && !Number.isNaN(r) && t[r] === h || !t,v = i.useMemo(() => {
      const d = p ? {
        width: p.getBoundingClientRect().width,
        height: p.getBoundingClientRect().height
      } : typeof window < "u" ? {
        width: window.innerWidth,
        height: window.innerHeight
      } : {
        width: 0,
        height: 0
      };
      var D;
      return (D = t == null ? void 0 : t.map((b) => {
        const H = typeof b == "string";
        let I = 0;
        if (H && (I = parseInt(b, 10)), N(s)) {
          const c = H ? I : w ? b * d.height : 0;
          return w ? s === "bottom" ? d.height - c : -d.height + c : c;
        }
        const V = H ? I : w ? b * d.width : 0;
        return w ? s === "right" ? d.width - V : -d.width + V : V;
      })) != null ? D : [];
    }, [
    t,
    w,
    p]
    ),M = i.useMemo(() => C !== null ? v == null ? void 0 : v[C] : null, [
    v,
    C]
    ),P = i.useCallback((d) => {
      var D;
      const b = (D = v == null ? void 0 : v.findIndex((H) => H === d)) != null ? D : null;
      l(b), A(a.current, {
        transition: `transform ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
        transform: N(s) ? `translate3d(0, ${d}px, 0)` : `translate3d(${d}px, 0, 0)`
      }), v && b !== v.length - 1 && r !== void 0 && b !== r && b < r ? A(o.current, {
        transition: `opacity ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
        opacity: "0"
      }) : A(o.current, {
        transition: `opacity ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
        opacity: "1"
      }), g(t == null ? void 0 : t[Math.max(b, 0)]);
    }, [
    a.current,
    t,
    v,
    r,
    o,
    g]
    );
  i.useEffect(() => {
    if (h || e) {
      var d;
      const D = (d = t == null ? void 0 : t.findIndex((b) => b === e || b === h)) != null ? d : -1;
      v && D !== -1 && typeof v[D] == "number" && P(v[D]);
    }
  }, [
  h,
  e,
  t,
  v,
  P]
  );
  function f({ draggedDistance: d, closeDrawer: D, velocity: b, dismissible: H }) {
    if (r === void 0) return;
    const I = s === "bottom" || s === "right" ? (M ?? 0) - d : (M ?? 0) + d,V = C === r - 1,c = C === 0,U = d > 0;
    if (V && A(o.current, {
      transition: `opacity ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`
    }), !x && b > 2 && !U) {
      H ? D() : P(v[0]);
      return;
    }
    if (!x && b > 2 && U && v && t) {
      P(v[t.length - 1]);
      return;
    }
    const W = v == null ? void 0 : v.reduce(($, J) => typeof $ != "number" || typeof J != "number" ? $ : Math.abs(J - I) < Math.abs($ - I) ? J : $),Y = N(s) ? window.innerHeight : window.innerWidth;
    if (b > Ot && Math.abs(d) < Y * 0.4) {
      const $ = U ? 1 : -1;
      if ($ > 0 && B && t) {
        P(v[t.length - 1]);
        return;
      }
      if (c && $ < 0 && H && D(), C === null) return;
      P(v[C + $]);
      return;
    }
    P(W);
  }
  function G({ draggedDistance: d }) {
    if (M === null) return;
    const D = s === "bottom" || s === "right" ? M - d : M + d;
    (s === "bottom" || s === "right") && D < v[v.length - 1] || (s === "top" || s === "left") && D > v[v.length - 1] || A(a.current, {
      transform: N(s) ? `translate3d(0, ${D}px, 0)` : `translate3d(${D}px, 0, 0)`
    });
  }
  function te(d, D) {
    if (!t || typeof C != "number" || !v || r === void 0) return null;
    const b = C === r - 1;
    if (C >= r && D)
    return 0;
    if (b && !D) return 1;
    if (!z && !b) return null;
    const I = b ? C + 1 : C - 1,V = b ? v[I] - v[I - 1] : v[I + 1] - v[I],c = d / Math.abs(V);
    return b ? 1 - c : c;
  }
  return {
    isLastSnapPoint: B,
    activeSnapPoint: h,
    shouldFade: z,
    getPercentageDragged: te,
    setActiveSnapPoint: g,
    activeSnapPointIndex: C,
    onRelease: f,
    onDrag: G,
    snapPointsOffset: v
  };
}
const qn = () => () => {
};
function Xn() {
  const { direction: e, isOpen: n, shouldScaleBackground: t, setBackgroundColorOnScale: a, noBodyStyles: o } = le(),r = i.useRef(null),l = Jt(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - Fe) / window.innerWidth;
  }
  i.useEffect(() => {
    if (n && t) {
      r.current && clearTimeout(r.current);
      const p = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!p) return;
      zn(a && !o ? $e(document.body, {
        background: "black"
      }) : qn, $e(p, {
        transformOrigin: N(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${O.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${O.EASE.join(",")})`
      }));
      const x = $e(p, {
        borderRadius: `${_t}px`,
        overflow: "hidden",
        ...(N(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        })
      });
      return () => {
        x(), r.current = window.setTimeout(() => {
          l ? document.body.style.background = l : document.body.style.removeProperty("background");
        }, O.DURATION * 1e3);
      };
    }
  }, [
  n,
  t,
  l]
  );
}
let he = null;
function Gn({ isOpen: e, modal: n, nested: t, hasBeenOpened: a, preventScrollRestoration: o, noBodyStyles: r }) {
  const [l, s] = i.useState(() => typeof window < "u" ? window.location.href : ""),p = i.useRef(0),x = i.useCallback(() => {
      if (rt() && he === null && e && !r) {
        he = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          height: document.body.style.height,
          right: "unset"
        };
        const { scrollX: g, innerHeight: w } = window;
        document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
          top: `${-p.current}px`,
          left: `${-g}px`,
          right: "0px",
          height: "auto"
        }), window.setTimeout(() => window.requestAnimationFrame(() => {
          const L = w - window.innerHeight;
          L && p.current >= w && (document.body.style.top = `${-(p.current + L)}px`);
        }), 300);
      }
    }, [
    e]
    ),h = i.useCallback(() => {
      if (rt() && he !== null && !r) {
        const g = -parseInt(document.body.style.top, 10),w = -parseInt(document.body.style.left, 10);
        Object.assign(document.body.style, he), window.requestAnimationFrame(() => {
          if (o && l !== window.location.href) {
            s(window.location.href);
            return;
          }
          window.scrollTo(w, g);
        }), he = null;
      }
    }, [
    l]
    );
  return i.useEffect(() => {
    function g() {
      p.current = window.scrollY;
    }
    return g(), window.addEventListener("scroll", g), () => {
      window.removeEventListener("scroll", g);
    };
  }, []), i.useEffect(() => {
    if (n)
    return () => {
      typeof document > "u" || document.querySelector("[data-vaul-drawer]") || h();
    };
  }, [
  n,
  h]
  ), i.useEffect(() => {
    t || !a || (e ? (!window.matchMedia("(display-mode: standalone)").matches && x(), n || window.setTimeout(() => {
      h();
    }, 500)) : h());
  }, [
  e,
  a,
  l,
  n,
  t,
  x,
  h]
  ), {
    restorePositionSetting: h
  };
}
function Pt({ open: e, onOpenChange: n, children: t, onDrag: a, onRelease: o, snapPoints: r, shouldScaleBackground: l = !1, setBackgroundColorOnScale: s = !0, closeThreshold: p = Un, scrollLockTimeout: x = Vn, dismissible: h = !0, handleOnly: g = !1, fadeFromIndex: w = r && r.length - 1, activeSnapPoint: L, setActiveSnapPoint: B, fixed: C, modal: z = !0, onClose: v, nested: M, noBodyStyles: P = !1, direction: f = "bottom", defaultOpen: G = !1, disablePreventScroll: te = !0, snapToSequentialPoint: d = !1, preventScrollRestoration: D = !1, repositionInputs: b = !0, onAnimationEnd: H, container: I, autoFocus: V = !1 }) {
  var c, U;
  const [W = !1, Y] = At({
      defaultProp: G,
      prop: e,
      onChange: (u) => {
        n == null || n(u), !u && !M && Ut(), setTimeout(() => {
          H == null || H(u);
        }, O.DURATION * 1e3), u && !z && typeof window < "u" && window.requestAnimationFrame(() => {
          document.body.style.pointerEvents = "auto";
        }), u || (document.body.style.pointerEvents = "auto");
      }
    }),[$, J] = i.useState(!1),[Z, ce] = i.useState(!1),[Wt, je] = i.useState(!1),ae = i.useRef(null),ye = i.useRef(null),Ce = i.useRef(null),Oe = i.useRef(null),de = i.useRef(null),fe = i.useRef(!1),_e = i.useRef(null),Ne = i.useRef(0),oe = i.useRef(!1),qe = i.useRef(!G),Xe = i.useRef(0),m = i.useRef(null),Ge = i.useRef(((c = m.current) == null ? void 0 : c.getBoundingClientRect().height) || 0),Ke = i.useRef(((U = m.current) == null ? void 0 : U.getBoundingClientRect().width) || 0),Ae = i.useRef(0),Ft = i.useCallback((u) => {
      r && u === me.length - 1 && (ye.current = /* @__PURE__ */new Date());
    }, []),{ activeSnapPoint: Bt, activeSnapPointIndex: ie, setActiveSnapPoint: Je, onRelease: kt, snapPointsOffset: me, onDrag: Lt, shouldFade: Ze, getPercentageDragged: zt } = jn({
      snapPoints: r,
      activeSnapPointProp: L,
      setActiveSnapPointProp: B,
      drawerRef: m,
      fadeFromIndex: w,
      overlayRef: ae,
      onSnapPointChange: Ft,
      direction: f,
      container: I,
      snapToSequentialPoint: d
    });
  $n({
    isDisabled: !W || Z || !z || Wt || !$ || !b || !te
  });
  const { restorePositionSetting: Ut } = Gn({
    isOpen: W,
    modal: z,
    nested: M ?? !1,
    hasBeenOpened: $,
    preventScrollRestoration: D,
    noBodyStyles: P
  });
  function xe() {
    return (window.innerWidth - Fe) / window.innerWidth;
  }
  function Vt(u) {
    var R, T;
    !h && !r || m.current && !m.current.contains(u.target) || (Ge.current = ((R = m.current) == null ? void 0 : R.getBoundingClientRect().height) || 0, Ke.current = ((T = m.current) == null ? void 0 : T.getBoundingClientRect().width) || 0, ce(!0), Ce.current = /* @__PURE__ */new Date(), St() && window.addEventListener("touchend", () => fe.current = !1, {
      once: !0
    }), u.target.setPointerCapture(u.pointerId), Ne.current = N(f) ? u.pageY : u.pageX);
  }
  function Qe(u, R) {
    var T;
    let y = u;
    const _ = (T = window.getSelection()) == null ? void 0 : T.toString(),k = m.current ? Re(m.current, f) : null,F = /* @__PURE__ */new Date();
    if (y.tagName === "SELECT" || y.hasAttribute("data-vaul-no-drag") || y.closest("[data-vaul-no-drag]"))
    return !1;
    if (f === "right" || f === "left")
    return !0;
    if (ye.current && F.getTime() - ye.current.getTime() < 500)
    return !1;
    if (k !== null && (f === "bottom" ? k > 0 : k < 0))
    return !0;
    if (_ && _.length > 0)
    return !1;
    if (de.current && F.getTime() - de.current.getTime() < x && k === 0 || R)
    return de.current = F, !1;
    for (; y;) {
      if (y.scrollHeight > y.clientHeight) {
        if (y.scrollTop !== 0)
        return de.current = /* @__PURE__ */new Date(), !1;
        if (y.getAttribute("role") === "dialog")
        return !0;
      }
      y = y.parentNode;
    }
    return !0;
  }
  function Yt(u) {
    if (m.current && Z) {
      const R = f === "bottom" || f === "right" ? 1 : -1,T = (Ne.current - (N(f) ? u.pageY : u.pageX)) * R,y = T > 0,_ = r && !h && !y;
      if (_ && ie === 0) return;
      const k = Math.abs(T),F = document.querySelector("[data-vaul-drawer-wrapper]"),Q = f === "bottom" || f === "top" ? Ge.current : Ke.current;
      let j = k / Q;
      const ne = zt(k, y);
      if (ne !== null && (j = ne), _ && j >= 1 || !fe.current && !Qe(u.target, y)) return;
      if (m.current.classList.add(He), fe.current = !0, A(m.current, {
        transition: "none"
      }), A(ae.current, {
        transition: "none"
      }), r && Lt({
        draggedDistance: T
      }), y && !r) {
        const K = Ln(T),be = Math.min(K * -1, 0) * R;
        A(m.current, {
          transform: N(f) ? `translate3d(0, ${be}px, 0)` : `translate3d(${be}px, 0, 0)`
        });
        return;
      }
      const ee = 1 - j;
      if ((Ze || w && ie === w - 1) && (a == null || a(u, j), A(ae.current, {
        opacity: `${ee}`,
        transition: "none"
      }, !0)), F && ae.current && l) {
        const K = Math.min(xe() + j * (1 - xe()), 1),be = 8 - j * 8,tt = Math.max(0, 14 - j * 14);
        A(F, {
          borderRadius: `${be}px`,
          transform: N(f) ? `scale(${K}) translate3d(0, ${tt}px, 0)` : `scale(${K}) translate3d(${tt}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!r) {
        const K = k * R;
        A(m.current, {
          transform: N(f) ? `translate3d(0, ${K}px, 0)` : `translate3d(${K}px, 0, 0)`
        });
      }
    }
  }
  i.useEffect(() => {
    window.requestAnimationFrame(() => {
      qe.current = !0;
    });
  }, []), i.useEffect(() => {
    var u;
    function R() {
      if (!m.current || !b) return;
      const T = document.activeElement;
      if (We(T) || oe.current) {
        var y;
        const _ = ((y = window.visualViewport) == null ? void 0 : y.height) || 0,k = window.innerHeight;
        let F = k - _;
        const Q = m.current.getBoundingClientRect().height || 0,j = Q > k * 0.8;
        Ae.current || (Ae.current = Q);
        const ne = m.current.getBoundingClientRect().top;
        if (Math.abs(Xe.current - F) > 60 && (oe.current = !oe.current), r && r.length > 0 && me && ie) {
          const ee = me[ie] || 0;
          F += ee;
        }
        if (Xe.current = F, Q > _ || oe.current) {
          const ee = m.current.getBoundingClientRect().height;
          let K = ee;
          ee > _ && (K = _ - (j ? ne : Fe)), C ? m.current.style.height = `${ee - Math.max(F, 0)}px` : m.current.style.height = `${Math.max(K, _ - ne)}px`;
        } else On() || (m.current.style.height = `${Ae.current}px`);
        r && r.length > 0 && !oe.current ? m.current.style.bottom = "0px" : m.current.style.bottom = `${Math.max(F, 0)}px`;
      }
    }
    return (u = window.visualViewport) == null || u.addEventListener("resize", R), () => {
      var T;
      return (T = window.visualViewport) == null ? void 0 : T.removeEventListener("resize", R);
    };
  }, [
  ie,
  r,
  me]
  );
  function ge(u) {
    jt(), v == null || v(), u || Y(!1), setTimeout(() => {
      r && Je(r[0]);
    }, O.DURATION * 1e3);
  }
  function et() {
    if (!m.current) return;
    const u = document.querySelector("[data-vaul-drawer-wrapper]"),R = Re(m.current, f);
    A(m.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`
    }), A(ae.current, {
      transition: `opacity ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
      opacity: "1"
    }), l && R && R > 0 && W && A(u, {
      borderRadius: `${_t}px`,
      overflow: "hidden",
      ...(N(f) ? {
        transform: `scale(${xe()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${xe()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      }),
      transitionProperty: "transform, border-radius",
      transitionDuration: `${O.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${O.EASE.join(",")})`
    }, !0);
  }
  function jt() {
    !Z || !m.current || (m.current.classList.remove(He), fe.current = !1, ce(!1), Oe.current = /* @__PURE__ */new Date());
  }
  function qt(u) {
    if (!Z || !m.current) return;
    m.current.classList.remove(He), fe.current = !1, ce(!1), Oe.current = /* @__PURE__ */new Date();
    const R = Re(m.current, f);
    if (!u || !Qe(u.target, !1) || !R || Number.isNaN(R) || Ce.current === null) return;
    const T = Oe.current.getTime() - Ce.current.getTime(),y = Ne.current - (N(f) ? u.pageY : u.pageX),_ = Math.abs(y) / T;
    if (_ > 0.05 && (je(!0), setTimeout(() => {
      je(!1);
    }, 200)), r) {
      kt({
        draggedDistance: y * (f === "bottom" || f === "right" ? 1 : -1),
        closeDrawer: ge,
        velocity: _,
        dismissible: h
      }), o == null || o(u, !0);
      return;
    }
    if (f === "bottom" || f === "right" ? y > 0 : y < 0) {
      et(), o == null || o(u, !0);
      return;
    }
    if (_ > Ot) {
      ge(), o == null || o(u, !1);
      return;
    }
    var k;
    const F = Math.min((k = m.current.getBoundingClientRect().height) != null ? k : 0, window.innerHeight);
    var Q;
    const j = Math.min((Q = m.current.getBoundingClientRect().width) != null ? Q : 0, window.innerWidth),ne = f === "left" || f === "right";
    if (Math.abs(R) >= (ne ? j : F) * p) {
      ge(), o == null || o(u, !1);
      return;
    }
    o == null || o(u, !0), et();
  }
  i.useEffect(() => (W && (A(document.documentElement, {
    scrollBehavior: "auto"
  }), ye.current = /* @__PURE__ */new Date()), () => {
    kn(document.documentElement, "scrollBehavior");
  }), [
  W]
  );
  function Xt(u) {
    const R = u ? (window.innerWidth - Se) / window.innerWidth : 1,T = u ? -16 : 0;
    _e.current && window.clearTimeout(_e.current), A(m.current, {
      transition: `transform ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
      transform: N(f) ? `scale(${R}) translate3d(0, ${T}px, 0)` : `scale(${R}) translate3d(${T}px, 0, 0)`
    }), !u && m.current && (_e.current = setTimeout(() => {
      const y = Re(m.current, f);
      A(m.current, {
        transition: "none",
        transform: N(f) ? `translate3d(0, ${y}px, 0)` : `translate3d(${y}px, 0, 0)`
      });
    }, 500));
  }
  function Gt(u, R) {
    if (R < 0) return;
    const T = (window.innerWidth - Se) / window.innerWidth,y = T + R * (1 - T),_ = -16 + R * Se;
    A(m.current, {
      transform: N(f) ? `scale(${y}) translate3d(0, ${_}px, 0)` : `scale(${y}) translate3d(${_}px, 0, 0)`,
      transition: "none"
    });
  }
  function Kt(u, R) {
    const T = N(f) ? window.innerHeight : window.innerWidth,y = R ? (T - Se) / T : 1,_ = R ? -16 : 0;
    R && A(m.current, {
      transition: `transform ${O.DURATION}s cubic-bezier(${O.EASE.join(",")})`,
      transform: N(f) ? `scale(${y}) translate3d(0, ${_}px, 0)` : `scale(${y}) translate3d(${_}px, 0, 0)`
    });
  }
  return i.useEffect(() => {
    z || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
  z]
  ), /* @__PURE__ */i.createElement(yn, {
    defaultOpen: G,
    onOpenChange: (u) => {
      !h && !u || (u ? J(!0) : ge(!0), Y(u));
    },
    open: W
  }, /* @__PURE__ */i.createElement(Rt.Provider, {
    value: {
      activeSnapPoint: Bt,
      snapPoints: r,
      setActiveSnapPoint: Je,
      drawerRef: m,
      overlayRef: ae,
      onOpenChange: n,
      onPress: Vt,
      onRelease: qt,
      onDrag: Yt,
      dismissible: h,
      shouldAnimate: qe,
      handleOnly: g,
      isOpen: W,
      isDragging: Z,
      shouldFade: Ze,
      closeDrawer: ge,
      onNestedDrag: Gt,
      onNestedOpenChange: Xt,
      onNestedRelease: Kt,
      keyboardIsOpen: oe,
      modal: z,
      snapPointsOffset: me,
      activeSnapPointIndex: ie,
      direction: f,
      shouldScaleBackground: l,
      setBackgroundColorOnScale: s,
      noBodyStyles: P,
      container: I,
      autoFocus: V
    }
  }, t));
}
const Mt = /* @__PURE__ */i.forwardRef(function ({ ...e }, n) {
  const { overlayRef: t, snapPoints: a, onRelease: o, shouldFade: r, isOpen: l, modal: s, shouldAnimate: p } = le(),x = Et(n, t),h = a && a.length > 0;
  if (!s)
  return null;
  const g = i.useCallback((w) => o(w), [
  o]
  );
  return /* @__PURE__ */i.createElement(Dn, {
    onMouseUp: g,
    ref: x,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": l && h ? "true" : "false",
    "data-vaul-snap-points-overlay": l && r ? "true" : "false",
    "data-vaul-animate": p != null && p.current ? "true" : "false",
    ...e
  });
});
Mt.displayName = "Drawer.Overlay";
const It = /* @__PURE__ */i.forwardRef(function ({ onPointerDownOutside: e, style: n, onOpenAutoFocus: t, ...a }, o) {
  const { drawerRef: r, onPress: l, onRelease: s, onDrag: p, keyboardIsOpen: x, snapPointsOffset: h, activeSnapPointIndex: g, modal: w, isOpen: L, direction: B, snapPoints: C, container: z, handleOnly: v, shouldAnimate: M, autoFocus: P } = le(),[f, G] = i.useState(!1),te = Et(o, r),d = i.useRef(null),D = i.useRef(null),b = i.useRef(!1),H = C && C.length > 0;
  Xn();
  const I = (c, U, W = 0) => {
    if (b.current) return !0;
    const Y = Math.abs(c.y),$ = Math.abs(c.x),J = $ > Y,Z = [
      "bottom",
      "right"].
      includes(U) ? 1 : -1;
    if (U === "left" || U === "right") {
      if (!(c.x * Z < 0) && $ >= 0 && $ <= W)
      return J;
    } else if (!(c.y * Z < 0) && Y >= 0 && Y <= W)
    return !J;
    return b.current = !0, !0;
  };
  i.useEffect(() => {
    H && window.requestAnimationFrame(() => {
      G(!0);
    });
  }, []);
  function V(c) {
    d.current = null, b.current = !1, s(c);
  }
  return /* @__PURE__ */i.createElement(Rn, {
    "data-vaul-drawer-direction": B,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": f ? "true" : "false",
    "data-vaul-snap-points": L && H ? "true" : "false",
    "data-vaul-custom-container": z ? "true" : "false",
    "data-vaul-animate": M != null && M.current ? "true" : "false",
    ...a,
    ref: te,
    style: h && h.length > 0 ? {
      "--snap-point-height": `${h[g ?? 0]}px`,
      ...n
    } : n,
    onPointerDown: (c) => {
      v || (a.onPointerDown == null || a.onPointerDown.call(a, c), d.current = {
        x: c.pageX,
        y: c.pageY
      }, l(c));
    },
    onOpenAutoFocus: (c) => {
      t == null || t(c), P || c.preventDefault();
    },
    onPointerDownOutside: (c) => {
      if (e == null || e(c), !w || c.defaultPrevented) {
        c.preventDefault();
        return;
      }
      x.current && (x.current = !1);
    },
    onFocusOutside: (c) => {
      if (!w) {
        c.preventDefault();
        return;
      }
    },
    onPointerMove: (c) => {
      if (D.current = c, v || (a.onPointerMove == null || a.onPointerMove.call(a, c), !d.current)) return;
      const U = c.pageY - d.current.y,W = c.pageX - d.current.x,Y = c.pointerType === "touch" ? 10 : 2;
      I({
        x: W,
        y: U
      }, B, Y) ? p(c) : (Math.abs(W) > Y || Math.abs(U) > Y) && (d.current = null);
    },
    onPointerUp: (c) => {
      a.onPointerUp == null || a.onPointerUp.call(a, c), d.current = null, b.current = !1, s(c);
    },
    onPointerOut: (c) => {
      a.onPointerOut == null || a.onPointerOut.call(a, c), V(D.current);
    },
    onContextMenu: (c) => {
      a.onContextMenu == null || a.onContextMenu.call(a, c), D.current && V(D.current);
    }
  });
});
It.displayName = "Drawer.Content";
const Kn = 250,Jn = 120,$t = /* @__PURE__ */i.forwardRef(function ({ preventCycle: e = !1, children: n, ...t }, a) {
    const { closeDrawer: o, isDragging: r, snapPoints: l, activeSnapPoint: s, setActiveSnapPoint: p, dismissible: x, handleOnly: h, isOpen: g, onPress: w, onDrag: L } = le(),B = i.useRef(null),C = i.useRef(!1);
    function z() {
      if (C.current) {
        P();
        return;
      }
      window.setTimeout(() => {
        v();
      }, Jn);
    }
    function v() {
      if (r || e || C.current) {
        P();
        return;
      }
      if (P(), !l || l.length === 0) {
        x || o();
        return;
      }
      if (s === l[l.length - 1] && x) {
        o();
        return;
      }
      const G = l.findIndex((d) => d === s);
      if (G === -1) return;
      const te = l[G + 1];
      p(te);
    }
    function M() {
      B.current = window.setTimeout(() => {
        C.current = !0;
      }, Kn);
    }
    function P() {
      B.current && window.clearTimeout(B.current), C.current = !1;
    }
    return /* @__PURE__ */i.createElement("div", {
      onClick: z,
      onPointerCancel: P,
      onPointerDown: (f) => {
        h && w(f), M();
      },
      onPointerMove: (f) => {
        h && L(f);
      },
      // onPointerUp is already handled by the content component
      ref: a,
      "data-vaul-drawer-visible": g ? "true" : "false",
      "data-vaul-handle": "",
      "aria-hidden": "true",
      ...t
    }, /* @__PURE__ */i.createElement("span", {
      "data-vaul-handle-hitarea": "",
      "aria-hidden": "true"
    }, n));
  });
$t.displayName = "Drawer.Handle";
function Zn({ onDrag: e, onOpenChange: n, open: t, ...a }) {
  const { onNestedDrag: o, onNestedOpenChange: r, onNestedRelease: l } = le();
  if (!o)
  throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */i.createElement(Pt, {
    nested: !0,
    open: t,
    onClose: () => {
      r(!1);
    },
    onDrag: (s, p) => {
      o(s, p), e == null || e(s, p);
    },
    onOpenChange: (s) => {
      s && r(s), n == null || n(s);
    },
    onRelease: l,
    ...a
  });
}
function Qn(e) {
  const n = le(),{ container: t = n.container, ...a } = e;
  return /* @__PURE__ */i.createElement(bn, {
    container: t,
    ...a
  });
}
const X = {
    Root: Pt,
    NestedRoot: Zn,
    Content: It,
    Overlay: Mt,
    Trigger: xn,
    Portal: Qn,
    Handle: $t,
    Close: En,
    Title: Sn,
    Description: Tn
  },er = "320px",tr = "600px",nr = "1025px",rr = "_isVisuallyHidden_1om8c_52",ar = "_drawer_1om8c_64",or = "_drawerOverlay_1om8c_71",ir = "_drawerContent_1om8c_77",sr = "_drawerHeader_1om8c_90",lr = "_drawerFooter_1om8c_102",ur = "_drawerTitle_1om8c_110",cr = "_drawerDescription_1om8c_116",ue = {
    mobile: er,
    "mobile-wide": "480px",
    tablet: tr,
    "tablet-wide": "800px",
    desktop: nr,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: rr,
    drawer: ar,
    drawerOverlay: or,
    drawerContent: ir,
    drawerHeader: sr,
    drawerFooter: lr,
    drawerTitle: ur,
    drawerDescription: cr
  },dr = ({
    shouldScaleBackground: e = !0,
    ...n
  }) => /* @__PURE__ */S(
    X.Root,
    {
      shouldScaleBackground: e,
      ...n
    }
  );
dr.displayName = "Drawer";
const Nr = X.Trigger,fr = X.Portal,Ar = X.Close,Ht = E.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */S(
    X.Overlay,
    {
      ref: t,
      className: se(ue.drawerOverlay, e),
      ...n
    }
  ));
Ht.displayName = X.Overlay.displayName;
const mr = E.forwardRef(({ className: e, children: n, ...t }, a) => /* @__PURE__ */Te(fr, { children: [
  /* @__PURE__ */S(Ht, {}),
  /* @__PURE__ */Te(
    X.Content,
    {
      ref: a,
      className: se(ue.drawerContent, e),
      ...t,
      children: [
      /* @__PURE__ */S("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
      n]

    }
  )]
}));
mr.displayName = "DrawerContent";
const gr = ({
  className: e,
  ...n
}) => /* @__PURE__ */S("div", { className: se(ue.drawerHeader, e), ...n });
gr.displayName = "DrawerHeader";
const pr = ({
  className: e,
  ...n
}) => /* @__PURE__ */S("div", { className: se(ue.drawerFooter, e), ...n });
pr.displayName = "DrawerFooter";
const hr = E.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */S(
  X.Title,
  {
    ref: t,
    className: se(ue.drawerTitle, e),
    ...n
  }
));
hr.displayName = X.Title.displayName;
const wr = E.forwardRef(({ className: e, ...n }, t) => /* @__PURE__ */S(
  X.Description,
  {
    ref: t,
    className: se(ue.drawerDescription, e),
    ...n
  }
));
wr.displayName = X.Description.displayName;
export {
  dr as Drawer,
  Ar as DrawerClose,
  mr as DrawerContent,
  wr as DrawerDescription,
  pr as DrawerFooter,
  gr as DrawerHeader,
  Ht as DrawerOverlay,
  fr as DrawerPortal,
  hr as DrawerTitle,
  Nr as DrawerTrigger };